var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoiceConfiguration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15V1L2.2 1.8L3.4 1L4.6 1.8L5.8 1L7 1.8L8.2 1L9.4 1.8L10.6 1L11.8 1.8L13 1L14.2 1.8L15.4 1V15L14.2 14.2L13 15L11.8 14.2L10.6 15L9.4 14.2L8.2 15L7 14.2L5.8 15L4.6 14.2L3.4 15L2.2 14.2L1 15ZM4 11.1H12V9.8H4V11.1ZM4 8.7H12V7.4H4V8.7ZM4 6.2H12V4.9H4V6.2ZM2.5 12.8H13.5V3.2H2.5V12.8Z",
    fill: "#8E97A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceConfiguration);
export default __webpack_public_path__ + "static/media/invoice-configuration.4fcaa8df42ed4b0b93d96eee8a2d4fd0.svg";
export { ForwardRef as ReactComponent };